import {
  action_crossed_swords,
  face_smile,
  etc_grape,
  body_walking_man,
  adults_only_kissing_couple,
  tree_icon,
  pointing_finger
} from '@assets/icons';
import { Frame, MenuTop, Text } from '@components';
import { useMain } from '@hooks';
import { colorSet } from '@theme';

const MainPage = () => {
  const {
    handleStandardClick,
    handleAdultsOnlyClick,
    handleActionGenreClick,
    handleBodyPartClick,
    handleFacialExpressionClick,
    handleEtcClick,
    handleThreeDClick
  } = useMain();

  return (
    <>
      <MenuTop />

      {/* 텍스트 및 버튼 리스트 */}
      <Frame width={1035} padding="48px 80px 96px 80px">
        <Text
          fontWeight="bold"
          marginBottom="54px"
          style={{ fontSize: '36px', lineHeight: '100%', textAlign: 'center' }}
        >
          테마를 선택해보세요.
        </Text>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)', // 4열
            gridTemplateRows: 'repeat(2, auto)', // 2행
            gap: '24px 25px' // 아이템 간격
          }}
        >
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleStandardClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={tree_icon} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                스탠다드 검색
              </Text>
            </div>
          </div>
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleAdultsOnlyClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={adults_only_kissing_couple} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                19금
              </Text>
            </div>
          </div>
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleActionGenreClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={action_crossed_swords} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                액션 장르
              </Text>
            </div>
          </div>
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleBodyPartClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={pointing_finger} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                신체부위
              </Text>
            </div>
          </div>
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleFacialExpressionClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={face_smile} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                표정
              </Text>
            </div>
          </div>
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleEtcClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={etc_grape} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                기타
              </Text>
            </div>
          </div>
          <div
            style={{
              width: 240,
              height: 200,
              backgroundColor: colorSet.gray100,
              border: `1px solid ${colorSet.gray300}`,
              borderRadius: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleThreeDClick}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={body_walking_man} alt="" style={{ width: 120, height: 120, marginBottom: '6px' }} />
              <Text variant="subtitle" fontWeight="bold">
                3D 소재
              </Text>
            </div>
          </div>
        </div>
      </Frame>
    </>
  );
};

export default MainPage;
